// extracted by mini-css-extract-plugin
export var gallery = "Gallery-module--gallery--Qes-q";